"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _iconsReact = require("../../icons-react");
var _HotelCardGallery = _interopRequireDefault(require("./components/HotelCardGallery"));
var _HotelCardHeaderLabel = _interopRequireDefault(require("./components/Labels/HotelCardHeaderLabel"));
var _HotelCardFacts = _interopRequireDefault(require("../HotelCardFacts/HotelCardFacts"));
var _HotelCardRating = _interopRequireDefault(require("./components/HotelCardRating"));
var _HotelCardTitle = _interopRequireDefault(require("./components/HotelCardTitle"));
var _HotelCardPrice = _interopRequireDefault(require("../HotelCardPrice/HotelCardPrice"));
var _HotelCardOfferInfo = require("./components/HotelCardOfferInfo");
var _HotelCardExploreButton = _interopRequireDefault(require("./components/HotelCardExploreButton"));
var _HotelCardSuggestedDates = _interopRequireDefault(require("../HotelCardSuggestedDates/HotelCardSuggestedDates"));
var _HotelCardMetaTitle = _interopRequireDefault(require("./components/HotelCardMetaTitle"));
var _HotelCardTags = _interopRequireDefault(require("./components/HotelCardTags"));
var _LabelList = require("../Label/LabelList");
var _cancellationPolicy = require("./components/utils/cancellationPolicy");
var _utils = require("../HotelCardFacts/utils");
var _FiltersPenalized = require("./components/FiltersPenalized");
var _WarningPlacesEnd = _interopRequireDefault(require("../WarningPlacesEnd"));
var _styles = require("./styles");
// Utils:

var HotelCard = function HotelCard(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$extras = _ref.extras,
    extras = _ref$extras === void 0 ? {} : _ref$extras,
    _ref$hotel = _ref.hotel,
    hotel = _ref$hotel === void 0 ? {} : _ref$hotel,
    _ref$suggestedDates = _ref.suggestedDates,
    suggestedDates = _ref$suggestedDates === void 0 ? [] : _ref$suggestedDates,
    _ref$isEmployee = _ref.isEmployee,
    isEmployee = _ref$isEmployee === void 0 ? false : _ref$isEmployee,
    _ref$labels = _ref.labels,
    labels = _ref$labels === void 0 ? null : _ref$labels,
    _ref$images = _ref.images,
    images = _ref$images === void 0 ? {
      count: 0,
      list: [],
      onSlideChange: function onSlideChange() {
        return undefined;
      }
    } : _ref$images,
    onConsoleClick = _ref.onConsoleClick,
    onEditClick = _ref.onEditClick,
    location = _ref.location,
    surcharge = _ref.surcharge,
    cancellationPolicy = _ref.cancellationPolicy,
    hasLtExtras = _ref.hasLtExtras,
    hotelHref = _ref.hotelHref,
    _ref$openInCurrentTab = _ref.openInCurrentTab,
    openInCurrentTab = _ref$openInCurrentTab === void 0 ? false : _ref$openInCurrentTab,
    price = _ref.price,
    currencyCode = _ref.currencyCode,
    nights = _ref.nights,
    date = _ref.date,
    isViewed = _ref.isViewed,
    bonus_count = _ref.bonus_count,
    _ref$penalized_filter = _ref.penalized_filters,
    penalized_filters = _ref$penalized_filter === void 0 ? [] : _ref$penalized_filter,
    onChangeFilter = _ref.onChangeFilter,
    dataLayer = _ref.dataLayer,
    isHotelOnly = _ref.isHotelOnly,
    cashbackIdentifier = _ref.cashbackIdentifier,
    customCashbackIconURL = _ref.customCashbackIconURL,
    customCashbackText = _ref.customCashbackText,
    customCashbackTooltipText = _ref.customCashbackTooltipText,
    isFlexDates = _ref.isFlexDates,
    availability = _ref.availability,
    _ref$isPreloadable = _ref.isPreloadable,
    isPreloadable = _ref$isPreloadable === void 0 ? false : _ref$isPreloadable,
    _ref$isMapCard = _ref.isMapCard,
    isMapCard = _ref$isMapCard === void 0 ? false : _ref$isMapCard,
    closeHotelPopup = _ref.closeHotelPopup;
  var rating = hotel.rating,
    stars = hotel.stars,
    _hotel$name = hotel.name,
    name = _hotel$name === void 0 ? '' : _hotel$name,
    _hotel$features = hotel.features,
    features = _hotel$features === void 0 ? {} : _hotel$features;
  var line = features.line,
    beach_surface = features.beach_surface,
    beach_distance = features.beach_distance,
    airport_distance = features.airport_distance,
    wi_fi = features.wi_fi;
  var emptyFeature = (0, _utils.isEmptyFeatures)(features);
  var cheap = extras.cheap,
    cheap_type = extras.cheap_type,
    previous_price = extras.previous_price,
    instant_confirm = extras.instant_confirm;
  var maxLabels = 6;
  if (instant_confirm) maxLabels -= 1;
  if ((0, _cancellationPolicy.isFreeCancellation)(cancellationPolicy)) maxLabels -= 1;
  var hasLabel = !(0, _isEmpty2["default"])(labels);
  var headerLabel = hasLabel ? labels === null || labels === void 0 ? void 0 : labels.find(function (label) {
    var _label$context;
    return ((_label$context = label.context) === null || _label$context === void 0 ? void 0 : _label$context.search) === 1;
  }) : undefined;
  var innerLabels = hasLabel ? labels === null || labels === void 0 ? void 0 : labels.filter(function (label) {
    var _label$context2;
    return ((_label$context2 = label.context) === null || _label$context2 === void 0 ? void 0 : _label$context2.search) === 2;
  }) : undefined;
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    hovered = _React$useState2[0],
    setHovered = _React$useState2[1];
  var hoverListener = _react["default"].useCallback(function (event) {
    setHovered(event.type === 'mouseenter');
  }, []);
  var openHotelInNewTab = function openHotelInNewTab() {
    Object.assign(document.createElement('a'), {
      target: openInCurrentTab ? '_self' : '_blank',
      rel: 'noopener noreferrer',
      href: hotelHref
    }).click();
  };
  var onClosePopup = function onClosePopup(e) {
    e.stopPropagation();
    closeHotelPopup === null || closeHotelPopup === void 0 || closeHotelPopup();
  };
  return /*#__PURE__*/_react["default"].createElement(StyledHotelCard, {
    onMouseEnter: hoverListener,
    onMouseLeave: hoverListener,
    itemScope: true,
    itemType: "https://schema.org/Hotel"
  }, headerLabel && !isMapCard ? /*#__PURE__*/_react["default"].createElement(_HotelCardHeaderLabel["default"], headerLabel) : null, /*#__PURE__*/_react["default"].createElement(StyledHotelOfferCardContent, {
    className: className,
    hasLabel: hasLabel,
    $isMapCard: isMapCard
  }, /*#__PURE__*/_react["default"].createElement(StyledImageContainer, null, /*#__PURE__*/_react["default"].createElement(_HotelCardGallery["default"], {
    images: images,
    isViewed: isViewed,
    bonusCount: bonus_count,
    cashbackIdentifier: cashbackIdentifier,
    customCashbackIconURL: customCashbackIconURL,
    customCashbackText: customCashbackText,
    customCashbackTooltipText: customCashbackTooltipText,
    currencyCode: currencyCode,
    isPreloadable: isPreloadable
  }), /*#__PURE__*/_react["default"].createElement(StyledHotelCardRating, {
    rating: rating
  })), /*#__PURE__*/_react["default"].createElement(StyledContentContainer, {
    onClick: isMapCard ? openHotelInNewTab : undefined
  }, /*#__PURE__*/_react["default"].createElement(StyledContentMain, {
    $isMapCard: isMapCard
  }, isMapCard && /*#__PURE__*/_react["default"].createElement(StyledCloseButton, {
    onClick: onClosePopup
  }, /*#__PURE__*/_react["default"].createElement(StyledCloseIcon, {
    width: 12
  })), /*#__PURE__*/_react["default"].createElement(_HotelCardMetaTitle["default"], {
    starCount: stars,
    location: location,
    isEmployee: isEmployee,
    onConsoleClick: onConsoleClick,
    onEditClick: onEditClick,
    $isMapCard: isMapCard
  }), /*#__PURE__*/_react["default"].createElement(StyledTitleRow, null, /*#__PURE__*/_react["default"].createElement(_HotelCardTitle["default"], {
    isMapCard: isMapCard,
    name: name,
    href: hotelHref,
    hasLtExtras: hasLtExtras,
    dataLayer: dataLayer
  }), !emptyFeature ? /*#__PURE__*/_react["default"].createElement(StyledHotelCardFacts, {
    line: line,
    beachDistance: beach_distance,
    airportDistance: airport_distance,
    beachSurface: beach_surface,
    wifiType: wi_fi
  }) : null), /*#__PURE__*/_react["default"].createElement(StyledTagWrapper, null, /*#__PURE__*/_react["default"].createElement(_LabelList.LabelList, {
    labels: innerLabels,
    maxLabels: maxLabels
  }), /*#__PURE__*/_react["default"].createElement(_HotelCardTags["default"], {
    extras: extras,
    cancellationPolicy: cancellationPolicy,
    isHotelOnly: isHotelOnly
  })), /*#__PURE__*/_react["default"].createElement(StyledPriceRow, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_WarningPlacesEnd["default"], {
    flight: availability.flight,
    hotel: availability.hotel,
    isHotelOnly: isHotelOnly
  }), /*#__PURE__*/_react["default"].createElement(StyledHotelCardPrice, {
    price: price,
    currencyCode: currencyCode,
    cheapType: cheap_type,
    oldPrice: previous_price,
    href: hotelHref,
    instantConfirm: instant_confirm,
    dataLayer: dataLayer,
    isSmallCard: false,
    isMapCard: isMapCard
  }), !isMapCard && /*#__PURE__*/_react["default"].createElement(_HotelCardOfferInfo.HotelCardOfferInfo, {
    date: date,
    nightsCount: nights,
    surcharge: surcharge,
    currencyCode: currencyCode,
    isHotelOnly: isHotelOnly,
    isFlexDates: isFlexDates
  })), !isMapCard && /*#__PURE__*/_react["default"].createElement(StyledExploreButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_HotelCardExploreButton["default"], {
    isCardHovered: hovered,
    dataLayer: dataLayer,
    href: hotelHref,
    isHotelOnly: isHotelOnly,
    openInCurrentTab: openInCurrentTab
  })))), !isMapCard && !(0, _isEmpty2["default"])(suggestedDates) && /*#__PURE__*/_react["default"].createElement(StyledSuggestedWrapper, null, /*#__PURE__*/_react["default"].createElement(_HotelCardSuggestedDates["default"], {
    items: suggestedDates,
    isHotelOnly: isHotelOnly
  })), /*#__PURE__*/_react["default"].createElement(_FiltersPenalized.FiltersPenalized, {
    penalized_filters: penalized_filters,
    onChangeFilter: onChangeFilter
  }))));
};
var StyledCloseButton = _styledComponents["default"].button.withConfig({
  displayName: "HotelCard__StyledCloseButton",
  componentId: "sc-18jp869-0"
})(["position:absolute;top:8px;right:8px;width:24px;height:24px;z-index:9;background-color:#e6e9ee;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;border:none;"]);
var StyledCloseIcon = (0, _styledComponents["default"])(_iconsReact.Close).withConfig({
  displayName: "HotelCard__StyledCloseIcon",
  componentId: "sc-18jp869-1"
})(["path{stroke-width:1.8;}"]);
var StyledHotelCard = _styledComponents["default"].div.withConfig({
  displayName: "HotelCard__StyledHotelCard",
  componentId: "sc-18jp869-2"
})(["border-radius:", ";width:100%;", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.shape.borderRadius;
}, _styles.fixScroll);
var StyledHotelOfferCardContent = _styledComponents["default"].div.withConfig({
  displayName: "HotelCard__StyledHotelOfferCardContent",
  componentId: "sc-18jp869-3"
})(["display:flex;position:relative;min-height:208px;overflow:hidden;background:", ";border-radius:", ";", " ", " ", ""], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shape.borderRadius;
}, _styles.fixScroll, function (_ref5) {
  var hasLabel = _ref5.hasLabel;
  return hasLabel && "\n      border-top-left-radius: 0px;\n      border-top-right-radius: 0px;\n    ";
}, function (_ref6) {
  var $isMapCard = _ref6.$isMapCard;
  return $isMapCard && "border-radius: 8px;";
});
var StyledImageContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelCard__StyledImageContainer",
  componentId: "sc-18jp869-4"
})(["flex:0 0 240px;position:relative;"]);
var StyledHotelCardRating = (0, _styledComponents["default"])(_HotelCardRating["default"]).withConfig({
  displayName: "HotelCard__StyledHotelCardRating",
  componentId: "sc-18jp869-5"
})(["position:absolute;z-index:10;top:8px;right:8px;"]);
var StyledContentContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelCard__StyledContentContainer",
  componentId: "sc-18jp869-6"
})(["min-width:0;display:flex;flex-direction:column;flex-grow:1;background:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.white;
});
var StyledPriceRow = _styledComponents["default"].div.withConfig({
  displayName: "HotelCard__StyledPriceRow",
  componentId: "sc-18jp869-7"
})(["position:relative;display:flex;justify-content:space-between;"]);
var StyledTitleRow = _styledComponents["default"].div.withConfig({
  displayName: "HotelCard__StyledTitleRow",
  componentId: "sc-18jp869-8"
})(["margin-bottom:auto;"]);
var StyledContentMain = _styledComponents["default"].div.withConfig({
  displayName: "HotelCard__StyledContentMain",
  componentId: "sc-18jp869-9"
})(["", " padding:8px 8px 8px 16px;display:flex;flex-direction:column;flex-grow:1;"], function (_ref8) {
  var $isMapCard = _ref8.$isMapCard;
  return $isMapCard && 'width: 100%;';
});
var StyledHotelCardFacts = (0, _styledComponents["default"])(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_HotelCardFacts["default"], props);
}).withConfig({
  displayName: "HotelCard__StyledHotelCardFacts",
  componentId: "sc-18jp869-10"
})(["margin-bottom:12px;"]);
var StyledTagWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelCard__StyledTagWrapper",
  componentId: "sc-18jp869-11"
})(["display:flex;flex-direction:column;margin-bottom:8px;"]);
var StyledHotelCardPrice = (0, _styledComponents["default"])(_HotelCardPrice["default"]).withConfig({
  displayName: "HotelCard__StyledHotelCardPrice",
  componentId: "sc-18jp869-12"
})(["display:flex;justify-content:flex-start;height:24px;"]);
var StyledSuggestedWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelCard__StyledSuggestedWrapper",
  componentId: "sc-18jp869-13"
})(["padding:0 8px 8px;"]);
var StyledExploreButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelCard__StyledExploreButtonWrapper",
  componentId: "sc-18jp869-14"
})(["position:relative;display:flex;flex-direction:column;justify-content:flex-end;:before{content:'';position:absolute;left:-50px;width:50px;height:46px;background-image:linear-gradient(90deg,rgba(255,255,255,0),#fff);}"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelCard);